import $ from "jquery";
import swiperSlider from "../swiperSlider/swiperSlider";

const uspComponent = {
    variables: {
        uspContainer: "usp-wrapper",
        uspTitle: "usp-title",
        uspSlider: ".usp-slider",
        url: window.location.href,
    },

    methods: {
        initialize: function () {
            if ($(window).width() < 768) {
                let swiperConfig = {
                    slidesPerView: 3,
                    spaceBetween: 16,
                };

                $(uspComponent.variables.uspSlider).length >= 1 &&
                    swiperSlider.methods.initializerSwiper(uspComponent.variables.uspSlider, swiperConfig);
            }
        },
         tileClickHandler: function () {
              $('.usp-card').on('click', function () {
                var buttonTitle = $(this).find('.usp-title').text().replace(/\s+/g, ' ').trim();
                var obj = uspComponent.methods.dataLayerObj(buttonTitle);
                createDataLayer('tileClick', obj);
              });
            },


        init: function () {
            uspComponent.methods.initialize();
        },
        dataLayerObj : function(e) {
                var obj = {
                    'articleName' : "",
                    'blogCategory' : "",
                    'blogPageCategory' : "",
                    'buttonText' : e?e:"",
                    'pageSection' : "USP Component",
                    'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? uspComponent.variables.url.includes("blog") ? "Blogs" : uspComponent.variables.url.substring(uspComponent.variables.url.indexOf(".com/"), uspComponent.variables.url.lastIndexOf('/')  === ".com") && !uspComponent.variables.url.substring(uspComponent.variables.url.indexOf(".com/"), uspComponent.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption' : "",
                    'productCategory' : "",
                    'productName' : "",
                    'question' : "",
                    'leadForm': "",
                    'source' : "",
                    'searchTerm' : "",
                    'videoTitle' : "",
                    'bannerName' : "",

                };
                return obj;
            }
       },
    };

// Document ready handler
$(document).ready(function () {
  uspComponent.methods.tileClickHandler();
});
if ($(`.${uspComponent.variables.uspContainer}`).length) {
    uspComponent.methods.init();
}

export default uspComponent;
